// extracted by mini-css-extract-plugin
export default {"contentDividerContainer":"c_Ft0eMRdDe50aHSN6qb","banner":"NeYve4EdT_v22klw4_Z5","desc":"BAkHXcsmoPDWUQOWe2wn"};